import { Box, Skeleton } from '@mui/material'
import React from 'react'

const LoaderHomePage = () => {
  return (
    <Box width={'100%'}>
      {[...Array(5)].map((_, idx) => (
        <Skeleton
          key={idx}
          width={'100%'}
          height={180}
          sx={{
            transform: 'scale(1, .9)',
          }}
        />
      ))}
    </Box>
  )
}

export default LoaderHomePage
